export default __webpack_public_path__ + "static/media/P_Pato.4e3af5d4.svg";